import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const customerId=localStorage.getItem('userId')
        const documentVerify=localStorage.getItem("documentverify")
        const mobile=localStorage.getItem("mobile")
        
        if(customerId!==null ){
          this.router.navigateByUrl('/');

        }
        else{
          return true
        }

    }
}